import { router } from '@inertiajs/react'
import { HiCheckCircle } from 'react-icons/hi2'
import { SelectedUser } from './types'

type Props = {
  eventSlug: string
  eventTitle: string
  selectedUser: SelectedUser
  onGetStarted: () => void
}

export default function FormHomepage({ eventSlug, eventTitle, selectedUser, onGetStarted }: Props) {
  const handleChangeUser = () => {
    router.delete(`/${eventSlug}/change_user`)
  }

  const userPillLabel =
    selectedUser.mode === 'user' ? selectedUser.name : selectedUser.mode === 'self_service' ? 'Self Service' : ''

  return (
    <div className="min-h-screen w-full text-white" style={{ background: 'linear-gradient(180deg, #111d1e 50%, #004f51 100%)' }}>
      <div
        aria-hidden="true"
        className="pointer-events-none absolute right-[-160px] top-[-200px] h-[700px] w-[700px] rounded-full"
        style={{
          background: 'radial-gradient(circle at 35% 35%, rgba(147,213,0,0.45), rgba(0,190,214,0.18) 40%, transparent 70%)',
          filter: 'blur(40px)',
        }}
      />

      <div className="relative mx-auto flex min-h-screen w-full max-w-[800px] flex-col">
        <header className="flex items-center justify-between bg-black/20 px-10 py-8">
          <div className="flex items-center gap-6">
            <div className="font-display text-2xl font-medium tracking-tight">CE</div>
            <p className="font-display text-2xl font-medium">Exhibition Intelligence MVP</p>
          </div>
          <div className="rounded-md bg-white/5 px-4 py-3 text-sm font-semibold uppercase tracking-wide shadow-[inset_0_0_2px_0_rgba(255,255,255,0.6)]">
            {userPillLabel}
          </div>
        </header>

        <main className="flex flex-1 flex-col items-center gap-10 px-12 py-12">
          {/* Hero placeholder — production swaps in a real visual */}
          <div className="flex h-[280px] w-full items-center justify-center overflow-hidden rounded-2xl border-2 border-white/20 bg-white/10 backdrop-blur-lg">
            <p className="font-display text-sm font-semibold uppercase tracking-[0.3em] text-white/60">
              {eventTitle}
            </p>
          </div>

          <div className="flex w-full flex-col gap-8">
            <h1
              className="font-display text-5xl font-bold leading-[1.1] tracking-tight text-transparent"
              style={{
                backgroundImage: 'linear-gradient(97deg, #00bed6 9%, #93d500 90%)',
                WebkitBackgroundClip: 'text',
                backgroundClip: 'text',
              }}
            >
              Turn exhibition conversations into measurable outcomes.
            </h1>
            <p className="font-body text-lg leading-8 text-white">
              Capture, qualify, and convert leads instantly at your booth.
              <br />
              Real-time data sync for your sales team.
            </p>

            <ul className="flex flex-col gap-2">
              {['Real-time Lead Capture', 'Instant CRM Sync', 'Analytics Dashboard'].map((line) => (
                <li key={line} className="flex items-center gap-3 font-body text-lg text-white">
                  <HiCheckCircle className="h-6 w-6 text-[#93d500]" />
                  {line}
                </li>
              ))}
            </ul>

            <div className="mt-4 flex justify-end gap-4">
              <button
                type="button"
                onClick={handleChangeUser}
                className="rounded-md bg-white/5 px-8 py-4 font-display text-xl font-semibold text-white shadow-[inset_0_0_2px_0_rgba(255,255,255,0.6)] transition hover:bg-white/10"
              >
                Change User
              </button>
              <button
                type="button"
                onClick={onGetStarted}
                className="flex items-center gap-2 rounded-md bg-[#111d1e] px-8 py-4 font-display text-xl font-semibold tracking-tight text-white transition hover:bg-black"
              >
                Get Started
                <span aria-hidden="true">→</span>
              </button>
            </div>
          </div>
        </main>
      </div>
    </div>
  )
}
